module.exports = __webpack_public_path__ + "img/card-brands.453c6a6a.png";